export enum SegmentFormat {
    OnDemand,
    LiveWebcast
}